import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from '../../components/Loading/Loading';
import TermsConditions from '../../components/Submit/TermsConditions';
import ElectronicDelivery from '../../components/Submit/ElectronicDelivery';
import PrivacyPolicy from '../../components/Submit/PrivacyPolicy';
import LeaveDialog from '../../components/SaveDialog/LeaveDialog';
import withBackgroundImage from '../../HOC/withBackgroundImage';

import { Form, FormGroup, Label, Input, Button } from 'reactstrap';

import { setApplicationComplete, clearState, setApplicationId } from '../../actions/applicationAction';
import { CompleteApplication } from '../../utils/ApplicationApi';

import './Submit.scss';

import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  dataLayer: {
      pageCategory: 'Submit',
      event: 'Credit Card Step 7'
  }
}

class RatesFees extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoading: false,
      showTermsConditionsModal: false,
      showElectronicDeliveryModal: false,
      showPrivacyPolicyModal: false,
      termsChecked: false,
      electronicDeliveryChecked: false,
      privacyPolicyChecked: false,
      certifyChecked: false,
      leaveDialogOpen: false
    };

    this.termsDisplayed = false;
    this.electronicDeliveryDisplayed = false;
    this.privacyPolicyDisplayed = false;

    this.onClickCancel = this.onClickCancel.bind(this);
    this.onClickForward = this.onClickForward.bind(this);
    this.toggleTerms = this.toggleTerms.bind(this);
    this.toggleElectronicDelivery = this.toggleElectronicDelivery.bind(this);
    this.togglePrivacyPolicy = this.togglePrivacyPolicy.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.toggleDialog = this.toggleDialog.bind(this);
    this.closeOverlays = this.closeOverlays.bind(this);
  }

  componentDidMount() {
    TagManager.dataLayer(tagManagerArgs);
  }

  onClickForward(event) {
    event.preventDefault();
    if(this.props.application.verificationSent && this.props.application.applicationSent) {
      this.setState({showLoading: true});
      CompleteApplication().then(result => {
        if(result !== undefined) {          
          this.setState({showLoading: false});
          this.props.setApplicationComplete(true);          
          this.props.setApplicationId(result.data.id.value);
          this.props.history.replace('/WhatsNext');
        }
      });
    }
  }
  onClickCancel() {
    // Clear out all app data
    this.props.clearState();
    //rediret to Vancity.com
    window.location.replace("https://www.vancity.com")
  }
  toggleTerms(event) {
    event.preventDefault();
    this.setState({
      showTermsConditionsModal: !this.state.showTermsConditionsModal,
      termsChecked: this.termsDisplayed ? this.state.termsChecked : !this.state.termsChecked
    });    
    this.termsDisplayed = true;
  }
  toggleElectronicDelivery(event) {    
    event.preventDefault();
    this.setState({
      showElectronicDeliveryModal: !this.state.showElectronicDeliveryModal,
      electronicDeliveryChecked: this.electronicDeliveryDisplayed ? this.state.electronicDeliveryChecked : !this.state.electronicDeliveryChecked
    });
    this.electronicDeliveryDisplayed = true;
  }
  togglePrivacyPolicy(event) {
    event.preventDefault();
    this.setState({
      showPrivacyPolicyModal: !this.state.showPrivacyPolicyModal,
      privacyPolicyChecked: this.privacyPolicyDisplayed ? this.state.privacyPolicyChecked : !this.state.privacyPolicyChecked
    });
    this.privacyPolicyDisplayed = true;
  }
  toggleCheckbox(event) {
    if(event.target.checked) {
      if(event.target.name === "termsChecked" && !this.termsDisplayed) {
        this.toggleTerms(event);        
      }
      else if(event.target.name === "electronicDeliveryChecked" && !this.electronicDeliveryDisplayed) {
        this.toggleElectronicDelivery(event);
      }
      else if(event.target.name === "privacyPolicyChecked" && !this.privacyPolicyDisplayed) {
        this.togglePrivacyPolicy(event);
      }
    }
    this.setState({[event.target.name]: event.target.checked});
  }
  toggleDialog() {
    this.setState({
      leaveDialogOpen: !this.state.leaveDialogOpen
    })
  }
  closeOverlays() {
    this.setState({
      showTermsConditionsModal: false,
      showElectronicDeliveryModal: false,
      showPrivacyPolicyModal: false
    });
  }
  render() {
    const forwardDisabled = (!this.state.termsChecked || !this.state.electronicDeliveryChecked || !this.state.privacyPolicyChecked || !this.state.certifyChecked);
    return (
      <div className="submit">
        <Loading visible={this.state.showLoading}>
          <div>Your application is being processed. This may take up to a few minutes.</div>
          <div>Please do not close or leave this page as your application will not be saved.</div>
        </Loading>
        <TermsConditions visible={this.state.showTermsConditionsModal} toggle={this.toggleTerms} onClickClose={this.closeOverlays} />
        <ElectronicDelivery visible={this.state.showElectronicDeliveryModal} toggle={this.toggleElectronicDelivery} onClickClose={this.closeOverlays}  />
        <PrivacyPolicy visible={this.state.showPrivacyPolicyModal} toggle={this.togglePrivacyPolicy} onClickClose={this.closeOverlays}  />
        <h1>You're ready to submit your application</h1>
        <p>Make sure to review the terms and conditions. When you click “Submit Visa application”, you’re confirming that you’ve read, understood and agree to the terms below.</p>
        <Form onSubmit={this.onClickForward}>
          <FormGroup check>
            <Input id="terms" type="checkbox" name="termsChecked" onClick={this.toggleCheckbox} checked={this.state.termsChecked} /> 
            <Label for="terms" check>I agree to the <a onClick={this.toggleTerms}>terms and conditions</a>.</Label>
          </FormGroup>
          <FormGroup check>
            <Input id="electronic-delivery" type="checkbox" name="electronicDeliveryChecked" onClick={this.toggleCheckbox} checked={this.state.electronicDeliveryChecked} />
            <Label for="electronic-delivery" check>I consent to the <a onClick={this.toggleElectronicDelivery}>disclosure of my personal information</a>.</Label>
          </FormGroup>
          <FormGroup check>
            <Input id="privary-policy" type="checkbox" name="privacyPolicyChecked" onClick={this.toggleCheckbox} checked={this.state.privacyPolicyChecked} />
            <Label for="privary-policy" check>I consent to Vancity <a onClick={this.togglePrivacyPolicy}>obtaining and using my credit bureau information</a> for the purpose of this application.</Label>
          </FormGroup>
          <FormGroup check>
            <Input id="certify" type="checkbox" name="certifyChecked" onClick={this.toggleCheckbox} checked={this.state.certifyChecked} />
            <Label for="certify" check>I certify that the information I provided is true, correct and complete</Label>
          </FormGroup>
          <div className="buttons-container">
            <Button color="primary" size="lg" type="submit" onClick={this.onClickForward} disabled={forwardDisabled}>Submit Visa application</Button>
            <Button color="link" className="back" onClick={this.toggleDialog}>Cancel</Button>
          </div>
        </Form>
        <LeaveDialog visible={this.state.leaveDialogOpen} toggle={this.toggleDialog} onClickLeave={this.onClickCancel} onClickCancel={this.toggleDialog} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  application: state.application
});

const mapDispatchToProps = dispatch => ({
  setApplicationComplete: (applicationComplete) => dispatch(setApplicationComplete(applicationComplete)),
  clearState: () => dispatch(clearState()),
  setApplicationId: (visaApplicationId) => dispatch(setApplicationId(visaApplicationId))
});


export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("review")(RatesFees));


// WEBPACK FOOTER //
// ./src/containers/Submit/Submit.js